import React from "react";
import HotelCard from "./HotelCard";

const HotelList: React.FC = () => {
  const hotels = [
    {
      name: "The Khyber Himalayan Resort & Spa",
      image: "/images/hotels/khyber.jpg", // Replace with actual image path
      description:
        "A luxurious retreat offering breathtaking views of the Himalayas.",
      price: "₹20,000",
    },
    {
      name: "Grand Mumtaz Resorts Gulmarg",
      image: "/images/hotels/grand-mumtaz.jpg", // Replace with actual image path
      description: "A premium hotel with modern amenities and cozy rooms.",
      price: "₹15,000",
    },
    {
      name: "Heevan Retreat Gulmarg",
      image: "/images/hotels/heevan.jpg", // Replace with actual image path
      description: "Experience comfort and hospitality in the lap of nature.",
      price: "₹12,000",
    },
    {
      name: "The Vintage Gulmarg",
      image: "/images/hotels/vintage.avif", // Replace with actual image path
      description: "Elegant rooms with scenic views and top-notch facilities.",
      price: "₹18,000",
    },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-6 p-4">
      {hotels.map((hotel, index) => (
        <HotelCard key={index} {...hotel} />
      ))}
    </div>
  );
};

export default HotelList;
